<template>
  <div id="tab-bar">
    <!--  <el-container>-->
    <el-header style="background-color: #e1e1e4">
      <div class="logoName fl">
        <img src="~assets/img/NokiaBellLogo2.jpg"  alt="Failed to load image" />
      </div>
      <div class="topdiv fl">
        <el-button
          class="topBtn toggle-button"
          id="menuBtn"
          @click="togleCollapse"
        >
          <i class="fa fa-bars"></i>
        </el-button>
        <el-button class="topBtn" id="indexBtn">
          <i class="fa fa-home"></i>
        </el-button>
        <el-badge class="item">
          <el-button class="topBtn" id="plainBtn" plain
            ><i class="fa fa-bell-o"></i
          ></el-button>
        </el-badge>
        <img
          src="~assets/img/seelablog.png"
          style="
            height: 60px;
            margin-top: 1px;
            display: inline-block;
            float: left;
          "
           alt="Failed to load image"
        />
      </div>
    
      <div class="usediv fr">
        <el-switch
          style="display: block ;margin-top: 3%"
          v-model="langinfo"
          @change="changeMyLanguage(langinfo)"
          active-color="#ff4949"
          inactive-color="#409EFF" 
          active-text="简体中文"
          inactive-text="English"
          :active-value="langCnnames"
          :inactive-value="langEnnames"

          >
        </el-switch>
        <div  style="margin-top: 4%">
        <el-dropdown >
          <span class="el-dropdown-link">
             {{ $t('WelcomeUsers')+"：" + userName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown">
            <el-dropdown-item
              ><span @mouseover="iSshow = false">{{ $t('Settings') }}</span></el-dropdown-item
            >
            <el-dropdown-item >
              <div class="testeldropdown" >
                <span class="el-dropdown-link" @mouseover="iSshow = true">
                  <i class="el-icon-arrow-left el-icon--left"></i>
               {{ $t('SwitchLanguage')}}
                </span>
                <div
                  class="testclass"
                  :style="iSshow ? 'display:block;' : 'display:none;'"
                >
                  <el-dropdown-item
                    v-for="item in languages"
                    :key="item.cultureName"
                    :command="item.cultureName"
                    @command="changeMyLanguage"
                    >
                    <div @click="changeMyLanguage(item.cultureName)">  {{ item.displayName }}</div>

                  </el-dropdown-item>
                </div>
              </div>
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">
              <span @mouseover="iSshow = false">{{ $t('LogOut') }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      </div>
    </el-header>

    <el-container>
      <el-scrollbar class="leftSide" :width="isCollapse ? '64px' : '220px'">
        <el-aside>
          <el-menu
            unique-opened
            :default-active="navselected"
            :collapse="isCollapse"
            :collapse-transition="false"
            :active="navselected"
          >
            <template v-for="menu in menuList">
              <el-menu-item
                v-if="!menu.children"
                :index="menu.url"
                :key="menu.id"
              >
                <i :class="menu.icon"></i>
                <span slot="title" @click="reload(menu.url)">{{
                  $t(menu.name)
                }}</span>
              </el-menu-item>
              <el-submenu v-else :index="menu.url" :keys="menu.id">
                <template slot="title">
                  <i :class="menu.icon"></i><span>{{ $t(menu.name)}}</span>
                </template>

                <template v-for="child in menu.children">
                  <el-menu-item
                    v-if="child.children.length==0"
                    :index="child.url"
                    :key="child.id"
                             @click="reload(child.url)"
                  >
                   {{
                      $t(child.name)
                    }}

                  </el-menu-item>
                  <el-submenu v-else :index="child.url" :keys="child.id">
                    <template slot="title">
                      <i :class="child.icon"></i><span>{{ $t(child.name) }}</span>
                    </template>

                    <template v-for="child2 in child.children">
                      <el-menu-item
                        :index="child2.url"
                        :keys="child2.id"
                        @click="reload(child2.url)"
                      >
                        {{ $t(child2.name) }}
                      </el-menu-item>
                    </template>
                  </el-submenu>
                </template>
              </el-submenu>
            </template>

          </el-menu>
        </el-aside>
      </el-scrollbar>

      <slot></slot>
      <!--    </el-container>-->
    </el-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { GetUserMenu, ChangeLanguage } from "../../../api/api";
import { setCookie, delCookie } from "../../../../utils/package-cookies";
import {
  setItemToLocalstorage,
  getItemFormLocalstorage,
} from "../../../../utils/package-localstorage";
import { refreshMyToken } from "../../../utils/util";
// import func from "../../../../vue-temp/vue-editor-bridge";

export default {
  name: "MainTabBar",
  components: {},
  data() {
    return {
      userName: "",
      menuList: [],
      iSshow: false,
      languages: [
        { displayName: "简体中文", cultureName: "zh-Hans" },
        { displayName: "English", cultureName: "en" },
      ],
      langinfo: "",
      langGetrerInfo :"",
      langCnnames: "zh-Hans",
      langEnnames: "en",
    };
  },
  async mounted() {

    this.userName = JSON.parse(
      JSON.stringify(window.localStorage.getItem("userName"))
    ).replace(/"/g, "");

    if (!getItemFormLocalstorage("menuData")) {
      this.getUserMenu();
    } else {
      this.menuList = getItemFormLocalstorage("menuData");
    }
    //定时刷新Token
    this.refreshToken();
    const { $store } = this
    this.langinfo = $store.getters.language
  },

  methods: {
    reload(e) {
      var that = this;
      this.$router.push({
        name: "/demo",
        query: {
          routerUrl: e,
        },
      });
    },
    logout: function () {
      var _this = this;
      this.$confirm(_this.$t('wantToExit') + "?", _this.$t('LogOut'), {
        confirmButtonText: _this.$t('el.messagebox.confirm'),
        cancelButtonText: _this.$t('el.messagebox.cancel'),
        type: 'warning',
      })
        .then(() => {
          window.localStorage.removeItem("userId");
          window.localStorage.removeItem("userName");
          window.localStorage.removeItem("auth");
          window.localStorage.removeItem("TokenExpire");
          window.localStorage.removeItem("refreshtime");
          window.localStorage.removeItem("expires_in");
          window.localStorage.removeItem("menuData");
          window.localStorage.removeItem("language");
          sessionStorage.removeItem("Authorization");
          sessionStorage.removeItem("areaListForUser");
          sessionStorage.removeItem("area");
          sessionStorage.removeItem("deviceList");
          delCookie("auth");
          window.localStorage.removeItem("LocalIp");
          delCookie("LocalIp");
          global.antRouter = [];
          _this.$router.push("/login");
          window.location.reload();
        })
        .catch(() => {});
    },
    changeMyLanguage: function (command) {
      //修改当前选择的语言
      const { $store } = this
      $store.dispatch('setLanguage', command)
      $store.dispatch('applicationConfiguration',command).then((res) => {
        if(res.success){
            this.$message({
            message: this.$t('LangChange'),
            type: 'success'
          })
        }
      })
      ChangeLanguage({ LanguageName: command });
    },
    async getUserMenu() {
      var that = this;
      await GetUserMenu()
        .then(
          (res) => {
            if (res.success === true) {
               
              that.menuList = res.result;
              that.menuList.map((i) => {
                if (i.children.length == 0) {
                  delete i.children;
                }
              });
              setItemToLocalstorage("menuData", that.menuList);
            } else {
              that.$message.error(res.error.message);
            }
          },
          (err) => {
            that.$message.error(err.error.message);
          }
        )
        .catch((err) => {
          that.$message.error(err.error.message);
        });
    },
    openNotice() {
      this.$notify({
        title: this.$t('warn'),
        message: this.$t('warningMessage'),
        type: "warning",
      });
    },
    togleCollapse() {
      this.$store.commit("changeCollapse");
    },
    refreshToken() {
      var that = this;
      //已登录的进行token定时刷新
      setInterval(() => {
        //先检查是否已登录
        var curhref = window.location.href;
        //login页面不刷新、其他页面20分钟刷一次
        if (curhref.split("#").length > 1 && curhref.split("#")[1] == "/login")
          //登录页面不刷新
          return;
        //刷新token
        refreshMyToken(that);
      }, 1000 * 60);
    },
  },
  computed: mapState({
    isCollapse: (state) => state.isCollapse,
    navselected: (state) => state.adminleftnavnum,
  }),
};
</script>

<style scoped>
.dropdown span {
  width: 100%;
  display: block;
}

.testclass {
  position: absolute;
  top: 50px;
  right: 130px;
  width: 120px;
  background: #ffffff;
  padding: 10px 0px;
  /*box-shadow: 0px 0px 2px 2px #eeeeee;*/
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  text-align: center;
  color: #999;
}

.testclass > div:hover {
  color: #66b1ff;
  background: #ecf5ff;
}

.testclass > div {
  border-bottom: 1px solid #eee;
  line-height: 2.5;
}

#el-header {
  padding: 0;
  height: 60px;
  background-color: #e1e1e4;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}

.userName {
  line-height: 60px;
}

.logoName img {
  height: 65px;
  margin-top: 0px;
}

.topdiv {
  height: 60px;
  border-right: 1px solid #c1bec6;
}

.logoName {
  width: 220px;
  text-align: center;
}

.logoName img {
  width: 100%;
}
</style>
<style>
.el-aside {
  padding-bottom: 40px;
}
</style>
